
import { FC, ReactNode } from 'react';
import cx from 'classnames';
import Container from '@/components/Container';
import CollapsibleList from '@/components/Collapsible/CollapsibleList';
import { CollapsibleData } from '@/components/Collapsible/constants';
import useIsMobile from '@/custom_hooks/isMobile';

interface Collapsible1Props {
  className?: string;
  itemClassName?: string;
  data: CollapsibleData;
  imgSrc?: string;
  theme: "dark" | "light";
  includeBtn?: boolean;
  variant: "first" | "second";
  video?: boolean;
  button?: ReactNode; 
}

const Collapsible1: FC<Collapsible1Props> = ({ className, itemClassName, data, theme, variant, video, button }) => {
  const isMobile = useIsMobile();
  return (
    <section className={cx(theme == "dark" ? "bg-linear-gradient" : "bg-grey-200", className, "flex flex-col md:pb-16 pb-10 mx-4 md:mx-0 px-[22px] rounded-[18px] md:rounded-none")}>
      <Container>
        <div className="grid md:grid-cols-2 lg:mt-16 mt-10">
          <div className="flex flex-col gap-[22px] md:gap-[20px]">
            <h2 className={cx(theme == "dark" ? "text-grey-200" : "text-primary")}>
              {data.label}
            </h2>
            <p className={cx(theme == "dark" ? "text-tertiary" : "text-primary", "md:text-lg")}>{data.description}</p>
          </div>
          <div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 mt-[24px] md:mt-16">
  
          {isMobile && (
            <div className="mb-8">
              {video ? (
                <video
                  src={data.img_src}
                  autoPlay
                  loop
                  muted
                  playsInline
                  controls={false}
                  disablePictureInPicture
                  className="pointer-events-none rounded-[22px] w-[316px] h-[286px] object-cover"
                />
              ) : (
                <img
                  src={data.img_mob_src}
                  alt={data.img_alt}
                  className="rounded-[18px] w-full"
                />
              )}
            </div>
          )}


          {variant == "first" && (
            <>
              <div>
                <CollapsibleList data={data.items} itemClassName={itemClassName} />
              </div>

              {!isMobile && (
                <div className="pl-18">
                  {video ? (
                    <video
                      src={data.img_src}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="rounded-[22px] w-[524px] h-[496px] object-cover"
                    />
                  ) : (
                    <img
                      src={data.img_src}
                      alt={data.img_alt}
                      className="rounded-[18px] w-full"
                    />
                  )}
                </div>
              )}
            </>
          )}

          {variant === "second" && (
            <>
              {!isMobile && (
                <div className="mb-8 pr-18">
                  {video ? (
                    <video
                      src={data.img_src}
                      autoPlay
                      loop
                      muted
                      playsInline
                      className="rounded-[22px] w-[524px] h-[496px] object-cover"
                    />
                  ) : (
                    <img
                      src={data.img_src}
                      alt={data.img_alt}
                      className="rounded-[18px] w-full"
                    />
                  )}
                </div>
              )}

              <div>
                <CollapsibleList data={data.items} itemClassName={itemClassName} />
              </div>
              
            </>
          )}

            {button}
        </div>
      </Container>
    </section >
  )
}

export default Collapsible1;